export const FEATURE_FLAGS = {
  COMUNICACION_ENABLED: false,
  AI_ASSISTANT_ENABLED: true,
};
